<template>
    <div>
        <h1>抽選会管理ページ</h1>
        <v-container>
            <v-card>
                <v-card-title>{{ name }}</v-card-title>
            </v-card>
            <v-card>
                <router-link v-bind:to="{ name: 'eventview', params: { userId: userId, eventId: id } }">参加者登録ページ</router-link>
                <vue-qrcode v-if="qrcode" :value="qrcode" :options="option" tag="img"></vue-qrcode>
            </v-card>
            <v-card>
                <router-link v-bind:to="{ name: 'drawlot', params: { id: id } }">抽選ページ</router-link>
            </v-card>
        </v-container>
        <v-card-title>参加者一覧</v-card-title>
        <v-container>
            <v-flex v-for="participant in this.participants" :key="participant.name">
                <v-card class="d-flex flex-column">
                    <v-card-text>{{ participant.name }}</v-card-text>
                </v-card>
            </v-flex>
        </v-container>
    </div>
</template>
<script>
    import firebase from 'firebase'
    import VueQrcode from '@chenfengyuan/vue-qrcode';
    export default {
        components: {
            VueQrcode
        },
        data() {
            return {
                userId: "",
                id: "",
                name: "",
                newItem: {
                    name: "",
                    count: 0
                },
                participants: [],
                qrcode: "",
                option: {
                errorCorrectionLevel: "M",
                maskPattern: 0,
                margin: 5,
                scale: 2,
                width: 300,
                color: {
                    dark: "#000000FF",
                    light: "#FFFFFFFF"
                }
            }
            }
        },
        methods: {
        },
        async mounted() {
            const self = this;
            const user = firebase.auth().currentUser
            this.userId = user.uid
            const db = firebase.firestore()
            const userRef = db.collection("users").doc(user.uid)
            const eventRef = userRef.collection("events").doc(this.$route.params.id)
            this.id = eventRef.id
            const eventData = await eventRef.get()
            this.name = eventData.data().name

            //参加者一覧取得
            const participantsRef = eventRef.collection("participants")
            participantsRef.onSnapshot(function(querySnapshot) {
                self.participants = []
                querySnapshot.forEach(function(doc) {
                    self.participants.push({
                        id: doc.id,
                        name: doc.data().name
                    })
                })
            })

            const url = this.$router.resolve({
            name: 'eventview',
            params: {
                userId: this.userId,
                eventId: this.id
            }
            }).href
            this.qrcode = location.origin + url
        }
    }

</script>